import { createFileRoute } from "@tanstack/react-router";
import { PatientTabs } from "@/components/patients/patient/PatientTabs";

export const Route = createFileRoute("/dashboard/patients/$id/")({
  component: PatientProfilePage,
});

function PatientProfilePage() {
  return (
    <div className="mb-8 max-w-7xl mx-auto">
      <PatientTabs />
    </div>
  );
}
